module.exports = __webpack_public_path__ + "28b67065/img/print-icon.d8dbbca5.svg";